import {connect} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import StoreListWhere from "../../../where/StoreListWhere";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as formatter from "../../../../../config/formatter";
import * as o2Api from "../../../../../api/api";
import "src/scss/grid-styles.scss";
import StoreCornerListWhere from "../../../where/StoreCornerListWhere";
import {Loading} from "../../../../../components/common";

const {RangePicker} = DatePicker;
const CornerRejectReport = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [gridData, setGridData] = useState([]);
    const [selected, setSelected] = useState({
        storeCd: "", storeNm: "", saleDt: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "", cornerCd: "",
        fromSaleDt: dayjs(), toSaleDt: dayjs()
    });

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "brandNm", headerName: "휴게소명", minWidth: 100, cellClass: "cell"},
        {field: "storeNm", headerName: "매장명", minWidth: 100, cellClass: "cell"},
        {field: "cornerNm", headerName: "코너명", minWidth: 100, cellClass: "cell"},
        {
            headerName: "판매", children: [
                {
                    field: "saleQty",
                    headerName: "수량",
                    minWidth: 50,
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "saleAmt",
                    headerName: "실매출액",
                    minWidth: 100,
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        },
        {
            headerName: "반품", children: [
                {
                    field: "rejectSaleQty",
                    headerName: "수량",
                    minWidth: 50,
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "rejectSaleAmt",
                    headerName: "실매출액",
                    minWidth: 100,
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        }
    ]);

    useEffect(() => {

    }, []);

    const onGridReady = useCallback((params) => {
        // gridRef.current.api.sizeColumnsToFit();
    }, [])

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    const search = () => {
        setError({
            visible: false,
            message: ""
        });

        const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            cornerCd: cornerCd,
            fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
        };

        setLoading(true);
        o2Api.getRejectCornerSale(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);
                setGridData(responseBody);
            }
        });
    };

    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                {loading ? <Loading/> : null}
                <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                    <StoreCornerListWhere account={props.account} selected={searchForm}
                                    onSelect={(c, v) => handleSelect(c, v)}/>
                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 80}}>기간</CInputGroupText>
                            <CInputGroupText style={{background: "white", height: 35}}>
                                <RangePicker bordered={false}
                                             separator={"~"}
                                             placeholder={""}
                                             locale={locale}
                                             value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
                                             onChange={(dayjs, dateString) => {
                                                 setSearchForm((state) => ({
                                                     ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
                                                 }));
                                             }}/>
                            </CInputGroupText>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CButton size={"sm"} onClick={search}>조회</CButton>
                    </CCol>
                </CForm>
                <div style={{height: 10}}/>
                <div className="ag-theme-alpine" style={{width: "100%", height: 550}}>
                    <AgGridReact
                        ref={gridRef}
                        onGridReady={onGridReady}
                        rowSelection={"single"}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={gridData}
                        animateRows={true}
                        defaultColDef={defaultColDef}
                        columnDefs={columnDefs}>
                    </AgGridReact>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(CornerRejectReport);
